import { render, staticRenderFns } from "./XomeInstallation.vue?vue&type=template&id=5030adc1&"
import script from "./XomeInstallation.vue?vue&type=script&lang=js&"
export * from "./XomeInstallation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports